import React, { useState, useEffect, useRef, useContext } from 'react'
import { Button } from 'primereact/button'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'; // To use confirmDialog method
import { Calendar } from 'primereact/calendar'
import { useNavigate } from "react-router-dom";
import { Messages } from 'primereact/messages';
import { Dialog, InputText, Password, Tag, Toast } from 'primereact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGear } from '@fortawesome/free-solid-svg-icons';


import { cancelarMemoRequest, changePermisoMemo, getAsistenciaMemo, getMemos, setAsistenciaMemo } from '../../../API/Gerencia/Comunicados/ComunicadosRequests'
import { getPersonal } from '../../../API/RRHH/Personal/PersonalRequests';
import { getSecciones } from '../../../API/RRHH/Secciones/SeccionesRequests';
import MemoPDFTest from './PDF/ComunicadoPDF';
import headerPng from '../../../Assets/Membrete/header.png';
import footerPng from '../../../Assets/Membrete/footer.png';


import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid'
import { getDatesProduccion } from '../../../Base/Services/Moment/Luxon'
import Card from '../../../Base/Components/Card/Card'
import Loader from '../../../Base/Components/Loader/Loader';
import { toastShow } from '../../../Base/Services/ToastService';
import { ArchivosExcelService } from '../../../Base/Services/ArchivosService';
import { getPosiciones } from '../../../API/RRHH/Posiciones/PosicionesRequests';
import jsPDF from 'jspdf';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { getFechaFormatoLarge } from '../../../Base/Services/FechasService';
import { sendEmailComunicado } from '../../../Base/Services/Email/EmailRequest'

const ComunicadosScreen = () => {


    const {userAuth} = useContext(AuthContext);
    const navigate = useNavigate();
    const [memos, setMemos] = useState([]);
    const [dates, setDates] = useState([new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()]);
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const messages = useRef(null);


    const [personas, setpersonas] = useState([]);
    const [secciones, setSecciones] = useState([]);
    const [posiciones, setPosiciones] = useState([])

    const [display, setDisplay] = useState(false);
    const [selected, setSelected] = useState([]);
    const [password, setPassword] = useState('');
    const [loadingPermiso, setLoadingPermiso] = useState(false);
    const [memoDist, setMemoDist] = useState(null);
    const [loadingDist, setLoadingDist] = useState(false);
    const [readyToSend, setReadyToSend] = useState()

    // ASISTENCIA
    const [dialogList, setDialogList] = useState(false);
    const [memoAsistencia, setMemoAsistencia] = useState(null);
    const [loadingAsistencia, setLoadingAsistencia] = useState(false);
    const [asistenciaList, setAsistenciaList] = useState([]);


    // CANCELAR COMUNICADO
    const [showDialogCancelar, setshowDialogCancelar] = useState(false);
    const [memoCancelar, setMemoCancelar] = useState(null);
    const [codigoAsistencia, setCodigoAsistencia] = useState(null)


    const noEditables = [3588, 3596, 3589]

    const distribuirMemo = async () => {
        setReadyToSend(false);
        setLoadingDist(true);
        let Destinatario = ''
        const dest = memoDist?.Destinatario.split(',');
        if (memoDist?.TipoDestinatario === 0) {
            const p = personas.filter(e => dest.includes(e.idpersonal + ''));
            const correos = p.map(e => e.Correo)
            Destinatario = correos.filter(e => e.includes('@ppf.com.hn')).toString()
        }
        if (memoDist?.TipoDestinatario === 1) {
            const p = personas.filter(e => dest.includes(e.idseccion + ''));
            const correos = p.map(e => e.Correo)
            Destinatario = correos.filter(e => e ? e.includes('@ppf.com.hn') : null).toString()
        }
        if (memoDist?.TipoDestinatario === 3) {
            Destinatario = 'ppf@ppf.com.hn';
            // Destinatario = 'lmedina@ppf.com.hn';
        }
        if (memoDist?.TipoDestinatario === 4) {
            let p = personas.filter(e => dest.includes(e.idposicion.toString()));
            if (dest.includes('H4')) {
                const add = ['03916', '06720', '05657', '06210', '03821']
                const n = personas.filter(e => add.includes(e.idpersonal + ''));
                p = [...p, ...n];
            }
            const correos = p.map(e => e.Correo)
            Destinatario = correos.filter(e => e.includes('@ppf.com.hn')).toString();
        }
        // EnviarCorreoMemo(memoDist, Destinatario);

        
        const doc = new jsPDF({
            unit: 'pt',
            format: 'letter',
            compress: true,
            putOnlyUsedFonts: true
        });

        setTimeout(async () => {
            document.getElementById('toPDF').innerHTML = memoDist?.Contenido;

            setTimeout(async() => {
                const a = await doc.html(document.getElementById('Comunicado'), {
                    // margin: [110, 60],
                    margin: [100, 50], // [110, 60]
                    callback: async (doc) => {
                        const pageCount = doc.internal.getNumberOfPages();
                        const pageSize = doc.internal.pageSize;


                        for (let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                            const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                            const footer = `${i} / ${pageCount}`;
                            doc.addImage(headerPng,
                                58, 40, pageWidth - 115, 55, { baseline: 'top' })
                            doc.addImage(footerPng,
                                58, pageHeight - 90, pageWidth - 115, 45, { baseline: 'bottom,' })
                            doc.text(footer, pageWidth - 80, pageHeight - 95, { baseline: 'bottom' });


                            if (!noEditables.includes(memoDist?.IdEstado)) {
                                doc.setFontSize(150);
                                doc.text('Borrador', 100, 200, {
                                    baseline: 'bottom',
                                    angle: -45,
                                    renderingMode: 'stroke'
                                });
                                doc.setFontSize(12);
                            }
                        }


                        // console.log('ENTRO A ENVIASR CORREO');
                        const pdfBase64 = doc.output('datauristring', { filename: `${memoDist}.pdf` })

                        const contenido = `<div style="font-size: 14">
                            <span>Comunicado: <strong>${memoDist?.Memo}</strong> </span><br/><br/>
                            <span>Asunto: <strong>${memoDist?.Asunto}</strong> </span><br/><br/>
                            <span>Fecha: <strong>${getFechaFormatoLarge(memoDist?.Fecha)}</strong> </span><br/><br/>
                            <span>Enlace: <a href='https://were.ppf.com.hn${process.env.REACT_APP_ENV}/Memo/Preview/${memoDist?.Memo}'>
                            <strong>${memoDist?.Memo}</strong><br/>
                            </a> </span>
                            <br/>
                            <br/>
                            <span>Este mensaje se ha generado automáticamente. Por favor no responder.</span>
                          </div>`

                          const objeto = {
                              to: Destinatario,
                              cc: '',
                            //   bcc: 'lmedina@ppf.com.hn',
                              subject: `Comunicado ${memoDist?.Memo}, ${memoDist?.Asunto}`,
                              html: contenido,
                              attachments: [{
                                  filename: `${memoDist?.Memo}.pdf`,
                                  path: pdfBase64
                                }]
                            }

                        const result = await sendEmailComunicado(objeto, memoDist?.Memo);

                        if (result) {
                            toastShow(toast, 'success', 'Comunicado distribuido con exito.')
                            toastShow(toast, 'success', 'Correo enviado.');
                        } else {
                            toastShow(toast, 'error', 'Correo no enviado.');
                        }
                        setLoadingDist(false);
                        setMemoDist(null);
                        buscarMemos();
                    }
                });

            }, 1000);



        }, 1000);

    }


    const showMemo = (memo) => {
        window.open(`${process.env.REACT_APP_ENV}/Memo/Preview/${memo?.Memo}`, memo?.Memo, 'height=1200,width=1000')
    }

    const memoTemplate = (memo) => {
        return <span onDoubleClick={e => {
            navigate(`${process.env.REACT_APP_ENV}/Admin/Memorandum/Edit/` + memo.Memo)
        }}>{memo.Memo}</span>
    }

    const EnviaTeplate = (memo) => {
        let t = []
        let envia = memo?.Envia?.split(',');

        if (memo.TipoEnvia === 0) {
            t = personas?.filter((p) => envia.includes(p.idpersonal)).map((e) => e.NombreEmpleado)
        }

        if (memo.TipoEnvia === 1) {
            t = secciones.filter((s) => envia.includes(s.IdSeccion + '')).map(e => e.Seccion)
        }

        return <span style={{ textTransform: 'capitalize' }}>{t.toString().replaceAll(',', ', ').toLowerCase()}.</span>
    }

    const DestinatarioTeplate = (memo) => {
        let t = []
        let envia = memo?.Destinatario?.split(',');

        if (memo.TipoDestinatario === 0) {
            t = personas.filter((p) => envia.includes(p.idpersonal + '')).map((e) => e.NombreEmpleado)
        }

        if (memo.TipoDestinatario === 1) {
            t = secciones.filter((s) => envia.includes(s.CodigoSeccion + '')).map(e => e.Seccion)
        }

        if (memo.TipoDestinatario === 2) {
            t = memo.Destinatario;
        }

        if (memo.TipoDestinatario === 3) {
            t = 'Personal PPF';
        }
        if (memo.TipoDestinatario === 4) {
            t = posiciones.filter((s) => envia.includes(s.CodigoPosicion + '')).map(e => e.Posicion)
        }

        return <span style={{ textTransform: 'capitalize' }}>{t.toString().replaceAll(',', ', ').toLowerCase()}.</span>
    }

    const tipoInformativoTemplate = (e) => {
        switch (e.TipoInformativo) {
            case 0:
                return <Tag style={{ width: 100 }} value='General' />
            case 1:
                return <Tag style={{ width: 100 }} severity="success" value='Transporte' />
            case 2:
                return <Tag style={{ width: 100 }} severity="info" value='Alimentación' />

            default:
                return <span></span>
        }
    }

    const estadoTemplate = (e) => {
        switch (e.IdEstado) {
            case 3587:
                return <Tag style={{ width: 100 }} severity="warning" value={e.StatusName} />
            case 3588:
                return <Tag style={{ width: 100 }} severity="primary" value={e.StatusName} />
            case 3589:
                return <Tag style={{ width: 100 }} severity="danger" value={e.StatusName} />
            case 3591:
                return <Tag style={{ width: 100 }} severity="info" value={e.StatusName} />
            case 3596:
                return <Tag style={{ width: 100 }} severity="success" value={e.StatusName} />

            default:
                return <span></span>
        }
    }


    const openModalPermiso = (rowData) => {
        setSelected(rowData);
        setPassword('')
        setDisplay(true);
    }

    const columns = [
        {
            header: 'ID',
            field: 'idMemo',
            frozen: true,
            className: 'XXsmall',
            hidden: userAuth?.IdRol === 1
        },
        {
            header: 'Fecha Creado',
            field: 'FechaCreadoTable',
            Format: 'DateTime',
            frozen: true,
            className: 'medium'
        },
        {
            header: 'Comunicado',
            field: 'Memo',
            Format: 'Template',
            body: (e) => memoTemplate(e),
            frozen: true,
            className: 'small',
            Sumary: 'count'
        },
        {
            header: 'Fecha publicación',
            field: 'FechaTable',
            Format: 'Date',
            className: 'Xsmall'
        },
        {
            header: 'Estado',
            field: 'StatusName',
            className: 'small',
            Format: 'Template',
            body: rowData => rowData.idMemo && estadoTemplate(rowData)
        },
        {
            header: 'Tipo Comunicado',
            field: 'TipoInformativo',
            Format: 'Template',
            body: rowData => rowData.idMemo && tipoInformativoTemplate(rowData),
            className: 'small'
        },

        {
            header: 'Asunto',
            field: 'Asunto',
            className: 'XXXlarge'
        },
        {
            header: 'Envia',
            field: 'Envia',
            Format: 'Template',
            body: (rowData) => rowData.idMemo &&  EnviaTeplate(rowData),
            className: 'XXXlarge'
        },
        {
            header: 'Destinatario',
            field: 'Destinatario',
            className: 'XXXlarge',
            Format: 'Template',
            body: (rowData) => rowData.idMemo && DestinatarioTeplate(rowData)
        },
        {
            header: 'Introduccion',
            field: 'Introduccion',
            className: 'XXXlarge',
        },
        {
            header: 'Conclusion',
            field: 'Conclusion',
            className: 'XXXlarge',
        },
        {
            header: 'UserName',
            field: 'UserName'
        },
        {
            header: 'Fecha Liberación',
            field: 'FechaPermiso1',
            Format: 'DateTime',
            className: 'large'
        },
        {
            header: 'Fecha Procesos',
            field: 'FechaPermiso2',
            Format: 'DateTime',
            className: 'large'
        },
        {
            header: 'Fecha Planta',
            field: 'FechaPermiso3',
            Format: 'DateTime',
            className: 'large'
        },
        {
            header: 'Liberar',
            field: 'Permiso1',
            frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Checkbox',
            setDisable: ({data}) => !noEditables.includes(data.IdEstado),
            onChange: (e, {data}) => {return data.idMemo && openModalPermiso({ ...data, permiso: 1 })},
        },
        {
            header: 'Procesos',
            field: 'Permiso2',
            frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Checkbox',
            setDisable: ({data}) => !noEditables.includes(data.IdEstado),
            onChange: (e, {data}) => {return data.idMemo && openModalPermiso({ ...data, permiso: 2 })},
        },
        {
            header: 'Planta',
            field: 'Permiso3',
            frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Checkbox',
            setDisable: ({data}) => !noEditables.includes(data.IdEstado),
            onChange: (e, {data}) => {return data.idMemo && openModalPermiso({ ...data, permiso: 3 })},
        },
        {
            header: 'Presidencia',
            field: 'PermisoPresidencia',
            frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Checkbox',
            setDisable: ({data}) => !noEditables.includes(data.IdEstado),
            onChange: (e, {data}) => {return data.idMemo && openModalPermiso({ ...data, permiso: 4 })},
        },

        {
            field: "IdArea",
            className: "",
            header: "",
            Format: "Botones",
            frozen: true,
            alignFrozen: "right",
            filter: false,
            Botones: [
              {
                icon: "pi pi-eye",
                tooltip: "Vista Previa",
                onClick: (rowData) => {
                    showMemo(rowData)
                },
              },
              {
                icon: "pi pi-users",
                tooltip: "Asistencia",
                tooltipOptions: { position: 'left' },
                onClick: (rowData) => {
                    setMemoAsistencia(rowData);
                    obtenerAsistencia(rowData);
                    setDialogList(true);
                },
              },
              {
                icon: "pi pi-ban",
                tooltip: "Cancelar",
                tooltipOptions: { position: 'left' },
                loadingDist: loadingDist,
                onClick: (rowData) => {

                    confirmDialog({
                        header: `Cancelar`,
                        message: `¿Cancelar Comunicado ${rowData?.Memo}?`,
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            cancelarMemo(rowData?.idMemo)
                        },
                        reject: () => { },
                        acceptLabel: 'Si',
                        rejectLabel: 'No'
                    })
                    // setshowDialogCancelar(true);
                    // setMemoCancelar(rowData);
                },
              },

              {
                // icon: "pi pi-send",
                // icon: loadingDist ? "pi pi-spin pi-spinner" : "pi pi-send",
                icon: "pi pi-send",
                tooltip: "Distribuír",
                tooltipOptions: { position: 'top' },
                disable: (rowData) => rowData.IdEstado !== 3596, 
                loading: loadingDist,
                onClick: (rowData) => {
                    confirmDialog({
                        header: `¿Esta seguro de distribuir el memorándum ${rowData.Memo}?`,
                        message: `Asunto: ${rowData.Asunto}. Una vez distribuido ya no se podra modificar.`,
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            setMemoDist(rowData);
                            setLoadingDist(true);
                        },
                        reject: () => { },
                        acceptLabel: 'Si',
                        rejectLabel: 'No'
                    })
                },
              },
            ],
        },
    ];

    const table = {
        Columns: columns,
        Data: memos
    }

    const columnsAsistencia = [
        {
            header: 'Fecha',
            field: 'fecha',
            Format: 'DateTime'
        },
        {
            header: 'Código',
            field: 'idpersonal',
            Format: 'Center',
            Sumary: 'count'
        },
        {
            header: 'Nombre',
            field: 'NombreEmpleado',
            className: 'XXXlarge',
        },
        {
            header: 'Seccion',
            field: 'seccion',
            className: 'XXXlarge'
        },
    ]

    const tableAsistencia = {
        Columns: columnsAsistencia,
        Data: asistenciaList,
    }

    const verificarAcceso = async (rol = 0) => {
        setLoadingPermiso(true)
        

        let permiso = null;

        switch (selected.permiso) {
            case 1:
                permiso = selected.Permiso1
                break;
            case 2:
                permiso = selected.Permiso2
                break;
            case 3:
                permiso = selected.Permiso3
                break;
            case 4:
                permiso = selected.PermisoPresidencia
                break;

            default:
                break;
        }

        const acceso = await changePermisoMemo({
            Usuario: userAuth.Usuario,
            Password: password,
            PermisoChange: selected.permiso,
            IdUsuario: userAuth.idUser,
            IdMemo: selected.idMemo,
            Permiso: !permiso,
            Rol: rol ? userAuth.Rol : null,
            Tipo: selected.TipoInformativo
        })
        if (acceso.length > 0) {
            if (acceso[0].success) {
                toastShow(toast, 'success', `Se actualizo la autorizacion del memo ${selected.Memo}`)
                buscarMemos()
                onHide();
                return;
            }
        }

        onHide();
        toastShow(toast, 'error', 'Acceso no autorizado.');
        setLoadingPermiso(false);
    }

    const cancelarMemo = async (idMemo) => {

        const Datos = {
            idMemo: idMemo,
            idUser: userAuth?.idUser
        }
        const resultado = await cancelarMemoRequest(Datos)

        if(resultado[0]?.ESTADO === 1){
            toastShow(toast, 'success', 'Cancelado', resultado[0]?.MENSAJE);
            buscarMemos()
            onHideCancelar()
        }else{
            toastShow(toast, 'error', "Error", resultado[0]?.MENSAJE)
        }
      
    }

    const onHide = () => {
        setDisplay(false);
        setPassword('')
        setSelected();
        setLoadingPermiso(false)
    }

    const onHideCancelar = () => {
        setMemoCancelar(null);
        setshowDialogCancelar(false);
        setPassword('');
    }

    const buscarMemos = async () => {
        setLoading(true);
        const a = getDatesProduccion(dates);
        const m = await getMemos(a);
        setMemos(m);
        setLoading(false);
    }

    const AsistenciaMemo = async () => {
        const user = JSON.parse(localStorage.getItem('ppfUser'));

        const codigo = codigoAsistencia?.length === 4 ? '0' + codigoAsistencia : codigoAsistencia;
        const a = await setAsistenciaMemo({
            idMemo: memoAsistencia.idMemo,
            IdUserRegister: user.idUser,
            idpersonal: codigo
        })
        if (a.length > 0) {
            if (a[0].error) {
                // toastShow(toast, 'error', a[0].messag);
                messages.current.show({ severity: 'error', summary: a[0].messag, life: 1000 });
            } else {
                let t = [...asistenciaList];
                t.push(a[0]);
                setAsistenciaList(t)
                // toastShow(toast, 'success', a[0].messag);
                messages.current.show({ severity: 'success', summary: a[0].messag, life: 1000 });
            }
        }
        setCodigoAsistencia('')

    }

    const getInfo = async () => {
        const p = await getPersonal();
        setpersonas(p);
        const s = await getSecciones();
        setSecciones(s)
        const sp = await getPosiciones();
        setPosiciones(sp)
    }

    const obtenerAsistencia = async (memo) => {
        setLoadingAsistencia(true);
        const t = await getAsistenciaMemo(memo.idMemo);
        setAsistenciaList(t)
        setLoadingAsistencia(false)
    }

    const renderFooter = () => {
        return (
            <div>
                <Button
                    label="Cancelar"
                    className="p-button-outlined"
                    icon="pi pi-times"
                    onClick={() => onHide()}
                />
                <Button
                    label="Aceptar"
                    // disabled={cambiandoPermiso}
                    loading={loadingPermiso}
                    icon="pi pi-check"
                    onClick={verificarAcceso}
                />
            </div>
        );
    };
    const renderFooterCancelar = () => {
        return (
            <div>
                <Button
                    label="Cancelar"
                    className="p-button-outlined"
                    icon="pi pi-times"
                    onClick={() => onHideCancelar()}
                />
                <Button
                    label="Aceptar"
                    // disabled={cambiandoPermiso}
                    loading={loadingPermiso}
                    icon="pi pi-check"
                    onClick={cancelarMemo}
                />
            </div>
        );
    };

    const onHideList = () => {
        setDialogList(false);
        setMemoAsistencia(null);
        setAsistenciaList([]);
    }

    useEffect(() => {
        buscarMemos();
        getInfo();
        window.document.title = 'PPF • Comunicados';
    }, [])


    useEffect(() => {
        if (readyToSend) {
            distribuirMemo();
        }
    }, [readyToSend])


    return (
        <div className='MemoList' id='listadoMemos' style={{ overflow: 'hidden' }}>
            <ConfirmDialog />
            <Loader loading={loading} querySelector={'.MemoList'} />
            <Toast ref={toast} style={{ zIndex: 10000 }} />
            <Card
                titulo={<div className='botones'>
                    <h1 style={{ marginTop: -8 }}>Comunicados</h1>
                    <Calendar value={dates} onChange={e => setDates(e.value)} showButtonBar dateFormat="dd/mm/yy" showIcon selectionMode="range" style={{ width: "250px", maxHeight: '3rem' }} monthNavigator yearNavigator yearRange='2010:2030' />
                    <Button icon={'pi pi-search'} className={'mx-1'} onClick={buscarMemos} tooltip='Buscar' tooltipOptions={{position: "top"}}  />
                    <Button icon={'pi pi-file-excel'} className={'mx-1'} tooltip='Excel' tooltipOptions={{position: "top",}}  onClick={e => ArchivosExcelService(memos, 'Comunicados')} />
                    <Button icon={'pi pi-plus'} className={'mx-1'} tooltip='Nuevo' tooltipOptions={{position: "top"}} onClick={e => navigate(`${process.env.REACT_APP_ENV}/Admin/Memorandum/New`, { replace: true })} />
                </div>}
                contenido={<div className='p-3'>
                    <div >
                        {/* TABLA */}
                        <div style={{ height: '88vh', marginTop: 10 }}>
                            <AgGrid table={table} />
                        </div>
                        <div style={{ visibility: 'hidden' }}>
                            <MemoPDFTest memoDist={memoDist} setReadyToSend={setReadyToSend} />
                        </div>
                    </div>
                </div>}
            />

            {/* APROBAR MEMO */}
            <Dialog
                className="modal__contenedor"
                header={`Aprobar Comunicado ${selected?.Memo}`}
                visible={display}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "500px" }}
                footer={renderFooter("displayResponsive")}
                onHide={() => setDisplay(false)}
            >
                <div className="d-flex flex-column  justify-content-center">
                    <strong>Asunto: {selected?.Asunto}</strong>
                    <strong>Ingrese la contraseña.</strong>
                    <div className="p-inputgroup">
                        <div style={{ width: 0, }}>
                            <input type={'text'} name='user' autoComplete="user" />
                            <input type={'password'} name='password' autoComplete="password" />
                        </div>
                        <Password
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            feedback={false}
                        />
                        <Button
                            // disabled={cambiandoPermiso}
                            loading={loadingPermiso}
                            onClick={(e) => verificarAcceso(true)}
                        >
                            <FontAwesomeIcon icon={faUserGear} />
                        </Button>
                    </div>
                </div>
            </Dialog>

            {/* CANCELAR MEMO */}
            <Dialog
                className="modal__contenedor"
                header={`Cancelar Comunicado ${memoCancelar?.Memo}`}
                visible={showDialogCancelar}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "500px" }}
                footer={renderFooterCancelar("displayResponsive")}
                onHide={() => onHideCancelar(false)}
            >
                <div className="d-flex flex-column  justify-content-center">
                    <strong>Asunto: {selected?.Asunto}</strong>
                    <strong>Ingrese la contraseña.</strong>
                    <div className="p-inputgroup">
                        <div style={{ width: 0, }}>
                            <input type={'text'} name='user' autoComplete="user" />
                            <input type={'password'} name='password' autoComplete="password" />
                        </div>
                        <Password
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            feedback={false}
                        />
                        <Button
                            // disabled={cambiandoPermiso}
                            loading={loadingPermiso}
                            onClick={cancelarMemo}
                        >
                            <FontAwesomeIcon icon={faUserGear} />
                        </Button>
                    </div>
                </div>
            </Dialog>


            <Dialog header={<div>
                <div className='d-flex'>
                    <h3>{memoAsistencia?.Memo}</h3>
                    <Button className='p-button-rounded p-button-outlined mx-2' icon='pi pi-replay' size={25} onClick={e => obtenerAsistencia(memoAsistencia)} />
                    <Button className='p-button-rounded p-button-outlined mx-1' icon='pi pi-file-excel' size={25} onClick={e => ArchivosExcelService(asistenciaList, `Asistencia ${memoAsistencia.Memo}`)} />
                    {memoAsistencia?.IdEstado === 3588 && <InputText
                        className='mx-5'
                        placeholder='Código personal'
                        value={codigoAsistencia}
                        onChange={e => setCodigoAsistencia(e.target.value)}
                        // useGrouping={false}
                        // maxFractionDigits={0}
                        onKeyDownCapture={e => {
                            if (e.key === 'Enter') {
                                AsistenciaMemo();
                            }
                        }}
                    />}
                    <br />
                    <Messages ref={messages} style={{ position: 'absolute', top: 0, right: 80, zIndex: 1000 }} />
                </div>
            </div>} visible={dialogList} style={{ width: '70vw' }} modal onHide={onHideList}>
                <div id="asistenciaContainer" style={{ height: '70vh' }}>
                    <Loader loading={loadingAsistencia} querySelector={'#asistenciaContainer'} />
                    <AgGrid table={tableAsistencia} />
                </div>
            </Dialog>

        </div>
    )
}


export default ComunicadosScreen